import React from 'react'
import Navbar from '../inc/Navbar'

import { Link } from "react-router-dom";

import ScrollToTop from "react-scroll-to-top";
import kpsmainbuild from "../images/kpsMani Build.png";



function AbriefHistory() {
    return (
        <div>
            <Navbar />
            <br />
            <br />
          
            <div className="album py-1">
                <div className="container">
                    <h1> KRISHNAGAR PUBLIC SCHOOL </h1>
                </div>
            </div>

            <div className='cbscschoolnadia'>
                <div className='album py-1'>
                    <div className='container mt-3'>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb">
                                <li style={{ color: "white" }} className="breadcrumb-item"><Link to="/" style={{ color: "darkBLue" }} >Home</Link></li>
                                <li className="breadcrumb-item active" style={{ color: "darkBLue" }} aria-current="page">A Brief History <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-chevron-double-right" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M3.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L9.293 8 3.646 2.354a.5.5 0 0 1 0-.708" />
                                    <path fill-rule="evenodd" d="M7.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L13.293 8 7.646 2.354a.5.5 0 0 1 0-.708" />
                                </svg></li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <ScrollToTop smooth top="100" color="darkgoldenrod" />
            <br />
            <div className="album py-0">
                <div className="container">

                    <div className="card-body">
                        <div className='welcometext'>
                            <h1 className="card-title mb-0"><b>A Brief History of KPS</b></h1>
                            <div className="col-md-5">
                                <hr style={{ color: "#1D4D93" }} />
                            </div>
                        </div>
                        <div className="album py-0">
                            <div className="container">
                                <div className="row">

                                    <div className="col-md-8 mt-3">
                                        <div className='mission'>
                                            <h3 style={{ color: "#1D4D93" }} className='mb-2'><b>"Ideas are funny little things, <br></br>
                                                They won't work unless you do."</b></h3>
                                            <p className='justify mb-2'>It rightly goes with the Management team of our school. The idea of setting a CBSE school in the heart of Krishnagar was a dream comes true. The school finally laid its foundation on 6th April, 2016 with a handful of students and 9 teachers. Henceforth its journey began with a prime objective of fostering young minds by rendering holistic approach to education.</p>
                                            <p className='justify mb-2'>At a prominent peaceful location on NH-34 at Palpara More,Krishnagar, the multi-storeyed school building and playgrounds with greenery all around the school campus is designed to cater the needs of young and growing minds.</p>
                                            <p className='justify mb-2'>The school boasts of the modern facilities. No efforts have been spared in creating an environment in which the students are challenged to seek excellence- academically, socially, physically, artistically and spiritually.</p>




                                        </div>
                                    </div>
                                    <div className="col-md-4 mt-3">

                                        <img src={kpsmainbuild} className="card-img-top" alt="KPS_photo" />


                                    </div>
<div className='mission'>
 <p className='justify mb-2 mt-3'>Well maintained airy classrooms safe and secure with efficient security guards, CCTV cameras, Hi-Tech access systems, earthquake resistance structures, latest fire-fighting equipments and smoke detectors are installed for the safety and benevolence of the students. There are separate hygienic toilets for girls and boys with filtered drinking water facility. Full time housekeeping staffs are appointed to ensure cleanliness and hygiene within the campus. Well-equipped science laboratory, maths lab, language lab, geography lab and well stocked library are some of the integral essentials in school. A sick room and medical facilities are provided according to their needs. The management has also looked at the paramount importance for safe passage of child into the school and back home by its self-owned fleet of well-designed school vehicles and buses manned by trained drivers. To enrich, compete and win academic excellence, the school incites remedial classes for students after its usual timings. </p>

                                         <p className='justify mb-2'>By implementing the computer labs with internet connection along with the latest hardware and software, our school has taken its first step in pursuit of an innovative and modern approach to teaching and learning. Though we have implemented this from the very beginning of 2016with the installation of smartboards in every class, yet its full-fledged approach to e-learning and teaching is implemented today in this era of lockdown. The dire need to impart education without hampering their regular course of studies will surely lead us to inaugurate a new approach to the system of education. This was only made possible due to the tireless efforts of our management and administration. </p>

                                          <p className='justify mb-2'>The three abilities or forces of success are –Desire, Knowledge or know how and Action to actualize our management had a vision or a dream. So, he gathered knowledge from all corners to take action and actualize it. They have also tirelessly provided the amenities to its staff members and students and considers everyone a part of their larger family. They maintain a transparency in their dealing with all the staff and teachers. So a loving bond exists among all its members.</p>
                                           <p className='justify mb-2'>Congenial and relevant working environment had made it possible to get the school affiliated to the CBSE in the year 2018 for Secondary Level. No sooner due to the grand infrastructure and dedicatedteachers, the school established its foothold, gained popularity and began to be counted as one of the most prestigious schools of the locality. Eventually, in the year 2019 with a considerable number of students, succeeded in getting its affiliation CBSE Senior Secondary Level within 3 years of establishment.</p>

                                            <p className='justify mb-2'>Today, the school already has more than 1500 students, 40 trained and specialist teachers and several more non-teaching staff and is constantly growing. We are now the only school in the district of Nadia offering such a huge variety of subjects including several skill subjects for the secondary and senior secondary level. </p>

</div>

                                </div>
                            </div>
                        </div>
                        <br />






                    </div>
                </div>
            </div>
            <br />


        </div>
    )
}

export default AbriefHistory